import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import serializeForm from 'form-serialize';
import { decrypt, loginEmail } from '../user-actions';
import FormError from '../../components/form-error/FormError';
import { isValidRedirectUrl } from '../../utils/normalizer';
import ButtonText from '../../components/button/button-text/ButtonText';
import styles from './login-email.module.less';
import Input2 from '../../components/input/input-2/Input2';
import RoundedButtonPrimary from '../../components/button/rounded-button-primary/RoundedButtonPrimary';
import withRouter from '../../components/hooks/withRouter';

class LoginEmail extends Component {
    login(e) {
        e.preventDefault();
        const state = serializeForm(e.target, { hash: true });
        const redirect = decodeURIComponent(this.props.redirect);
        const isPreWizard = !!redirect?.includes('temporaryProjectUserTokenId');
        this.props
            .login(state, isPreWizard)
            .then(() => {
                this.props.routeTo(isValidRedirectUrl(redirect) ? redirect : '/me');
            })
            .catch(() => {});
    }

    decryptEmailData = async (encryptedEmail, dispatch) => {
        try {
            const data = encryptedEmail ? await dispatch(decrypt(encryptedEmail)) : null;
            return data?.body?.decrypted;
        } catch (e) {
            return null;
        }
    };

    componentDidMount = async () => {
        const decryptedEmail = await this.decryptEmailData(this.props.encryptedEmail, this.props.dispatch);
        this.setState({
            decryptedEmail,
        });
    };

    generateEmailFormPart = ({ decryptedEmail, existingEmail, errors }) => {
        if (decryptedEmail) {
            return (
                <div className="input-group">
                    <label>E-post</label>
                    <div className={styles.emailContainer}>
                        <strong>{decryptedEmail}</strong>
                    </div>
                    <input id="input_email" name="username" type="hidden" value={decryptedEmail} />
                    <FormError error={errors.username} />
                </div>
            );
        } else {
            return (
                <Input2
                    id="input_email"
                    title="E-post"
                    fieldName="username"
                    type="email"
                    autoCapitalize="none"
                    value={existingEmail}
                    errors={errors}
                />
            );
        }
    };

    render() {
        const { resetPassword, user } = this.props;
        const errors = user.errors || {};
        const emailFormPart = this.generateEmailFormPart({
            decryptedEmail: this.state?.decryptedEmail,
            existingEmail: this.props.existingEmail,
            errors,
        });
        return (
            <div className={styles.loginEmailContainer}>
                <FormError error={errors.global} />
                <form onSubmit={(e) => this.login(e)} method="post">
                    {emailFormPart}
                    <Input2 fieldName="password" type="password" title="Passord" errors={errors} />

                    <RoundedButtonPrimary>Logg inn</RoundedButtonPrimary>
                </form>
                <div className={styles.buttonContainer}>
                    <ButtonText onClick={resetPassword} category="login-form" action="forgot-password">
                        Glemt passord?
                    </ButtonText>
                </div>
            </div>
        );
    }
}

LoginEmail.propTypes = {
    user: PropTypes.object.isRequired,
    routeTo: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    redirect: PropTypes.string,
    encryptedEmail: PropTypes.string,
    existingEmail: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
};

LoginEmail.defaultProps = {
    redirect: '',
};

const mapToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch, props) => ({
    routeTo: (path) => props.navigate(path),
    resetPassword: () => props.navigate('/reset-password'),
    login: (loginInfo, isPreWizard) => dispatch(loginEmail({ userInfo: loginInfo, origin: 'login-form', isPreWizard })),
    dispatch,
});

export default withRouter(connect(mapToProps, mapDispatchToProps)(LoginEmail));
